import Layout from '@/views/Layout.vue'
import Dashboard from '@/views/Dashboard.vue'

export default {
    path: '/campus',
    component: Layout,
    children: [
        {
            path: '',
            name: 'campus.list',
            component: Dashboard
        },
        {
            path: 'register',
            name: 'campus.register',
            component: () => import('@/views/Registration.vue')
        },
        {
            path: 'payment/*',
            name: 'campus.payment',
            component: () => import('@/views/Payment.vue')
        },
        {
            path: '*',
            name: 'campus.project',
            component: () => import('@/views/Project.vue')
        }
    ]
}
